import React from 'react';
import api from '../../services/api';
import { useMessage } from '../../components/Message';

const GameTable = ({ games, onEdit, onImageUpload, onDelete, onRowClick }) => {
    const { showMessage } = useMessage();

    const toggleGameStatus = async (game) => {
        try {
            await api.put(`/admin/games/${game.gameId}`, {  // ← Use game.gameId
                ...game,
                isActive: !game.isActive
            });
            showMessage(`Game ${!game.isActive ? 'activated' : 'deactivated'}`, 'success');
            window.location.reload();
        } catch (error) {
            showMessage(error.response?.data?.message || 'Failed to update status', 'error');
        }
    };

    return (
        <div className="admin-table-wrapper">
            <div className="admin-table-scroll">
                <table className="admin-data-table">
                    <thead>
                        <tr>
                            <th>Game ID</th>
                            <th>Name</th>
                            <th>Category</th>
                            <th>Difficulty</th>
                            <th>Plays</th>
                            <th>Status</th>
                            <th>Images</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {games.map(game => (
                            <tr key={game.id} onClick={() => onRowClick && onRowClick(game)} className="admin-table-row">
                                <td className="admin-table-cell">{game.gameId}</td>
                                <td className="admin-table-cell">{game.name}</td>
                                <td className="admin-table-cell">
                                    <span className={`admin-category-badge admin-category-${game.category}`}>{game.category}</span>
                                </td>
                                <td className="admin-table-cell">
                                    <span className={`admin-difficulty-badge admin-difficulty-${game.difficulty}`}>{game.difficulty}</span>
                                </td>
                                <td className="admin-table-cell">{game.playCount?.toLocaleString() || 0}</td>
                                <td className="admin-table-cell">
                                    <button 
                                        className={`admin-status-toggle ${game.isActive ? 'admin-status-active' : 'admin-status-inactive'}`}
                                        onClick={(e) => { e.stopPropagation(); toggleGameStatus(game); }}
                                    >
                                        {game.isActive ? 'Active' : 'Inactive'}
                                    </button>
                                </td>
                                <td className="admin-table-cell">
                                    <button 
                                        className="admin-btn-image"
                                        onClick={(e) => { e.stopPropagation(); onImageUpload(game); }}
                                    >
                                        🖼️ {game.hasBanner ? '✓' : '✗'}
                                    </button>
                                </td>
                                <td className="admin-table-cell admin-actions-cell">
                                    <button className="admin-btn-edit" onClick={(e) => { e.stopPropagation(); onEdit(game); }}>Edit</button>
                                    <button 
                                        className="admin-btn-delete" 
                                        onClick={(e) => { 
                                            e.stopPropagation(); 
                                            onDelete(game.gameId);  // ← Pass game.gameId, NOT game.id
                                        }}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default GameTable;